import { useMemo } from 'react';

import type { OnBoardingResponse, UserResponse } from '../types/api/response/user';
import useCompanyInfo, { makeFullDataDivisions } from './useCompanyInfo';

export default function useFetchUsers(companyId: string) {
  const { data, isLoading, isFetching, isError, refetch } =
    useCompanyInfo(companyId);

  const divisions = useMemo(() => makeFullDataDivisions(data), [data]);

  const users: UserResponse[] = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.employees.map((employee) => ({
      ...employee,
      role: data.roles.find((_elt) => _elt.id === employee.securityRoleId),
      division: divisions.find((_elt) => _elt.id === employee.divisionId),
      // Vue allégée (jalons de dates seuls) : suffisante pour les statuts affichés, les noms
      // résolus d'OnBoardingResponse ne sont pas fournis par la route consolidée.
      onBoarding: employee.onBoardingId
        ? (data.onBoardings.find(
            (_elt) => _elt.id === employee.onBoardingId
          ) as OnBoardingResponse | undefined)
        : undefined,
    }));
  }, [data, divisions]);

  const loading: boolean = isLoading || isFetching;

  return {
    users,
    divisions,
    roles: data?.roles,
    loading,
    // Exposés séparément pour les écrans qui ne doivent pas basculer en skeleton sur un refetch
    // d'arrière-plan (isFetching), ou qui remontent l'erreur eux-mêmes.
    isLoading,
    isError,
    refetchUsers: refetch,
  };
}
